import React from "react";
import HomeCarousel from "../HomeCarousel/HomeCarousel";
import Leagues from "../Leagues/Leagues";

const Home = () => {
  return (
    <div>
      <HomeCarousel></HomeCarousel>
      <Leagues />
    </div>
  );
};

export default Home;
